import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface ErrorFallbackProps {
  error: unknown;
  eventId: string | null;
  resetError: () => void;
}

const ErrorFallback = ({ error, eventId, resetError }: ErrorFallbackProps) => {
  const message = error instanceof Error ? error.message : String(error ?? "Unknown error");

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-6">
      <div className="max-w-lg w-full bg-card border border-border rounded-[0.875rem] p-8 shadow-elegant">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
            <AlertTriangle className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h1 className="font-display text-xl font-bold">Something went wrong</h1>
            <p className="text-xs text-muted-foreground">The Emerging Market</p>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-4">
          We've been notified and are looking into it. You can try again or head back home.
        </p>

        {message && (
          <pre className="text-xs bg-muted/40 border border-border rounded-md p-3 mb-4 overflow-auto max-h-32 whitespace-pre-wrap">
            {message}
          </pre>
        )}

        {eventId && (
          <p className="text-[11px] text-muted-foreground mb-5 font-mono">
            Reference ID: {eventId}
          </p>
        )}

        <div className="flex flex-wrap gap-2">
          <Button onClick={resetError} size="sm">Try again</Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;